import {PtAnchor as PtAcnhorData} from '@data/types';

const PtAnchor = (props: {node: PtAcnhorData}) => (
  <a id={props.node.anchorId} />
);

export default PtAnchor;
